// Module
var code = "<div class=\"fg-tabs-pane\" ng-show=\"tabs.active === pane\"> <div ng-if=\"tabs.active === pane || pane.renderAlways\" ng-transclude></div> </div> ";
// Exports
export default code;